<template>
  <yams-template>
    <template #header>
      <div class="mr-5">
        <h4 class="text-primary font-weight-bold">Vehicules ({{ lines }})</h4>
      </div>
      <div class="mr-4">
        <NavParcAuto></NavParcAuto>
      </div>
      <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
        <button type="button" class="btn " @click.prevent="changeAffichage('table')"
          :class="{ 'active': affichage === 'table' }">
          <i class="fa-solid fa-bars"></i>
        </button>
        <button type="button" class="btn " @click.prevent="changeAffichage('card')"
          :class="{ 'active': affichage === 'card' }">
          <i class="fa-solid fa-border-all"></i>
        </button>
      </div>
      <div class="px-1 d-flex">
        <button class="btn-yams btn-active mr-2" @click="openCreateModal()">
          Ajouter un vehicule <i class="fa-solid fa-plus"></i>
        </button>
      </div>
    </template>
    <template #content>
      <div class="card mb-5">
        <div class="card-body p-1">
          <DataTableBackend :key="key" :url="this.$store.getters.apiUrl + '/api/vehicules'" :view-mode="affichage"
            :columns="columns" :table="table" @row-click="openShowModal" @set-selected-rows="getSelection"
            @set-total-records="updateLines">
            <template #statut="slotProps">
              <span class="p-2 rounded-pill badge" :class="{
                'badge-primary': slotProps.data.statut === 'En course',
                'badge-success': slotProps.data.statut === 'Disponible',
                'badge-danger': slotProps.data.statut === 'Indisponible',
                'badge-warning': slotProps.data.statut === 'En intervention',
                'badge-secondary': slotProps.data.statut === 'Nouveau'
              }">
                {{ slotProps.data.statut }}
              </span>
            </template>
          </DataTableBackend>
        </div>
      </div>
    </template>
  </yams-template>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
import NavParcAuto from '@/views/parc-auto/NavParcAuto.vue';
const ShowVehicule = defineAsyncComponent(() => import('@/views/parc-auto/vehicules/ShowVehicule.vue'));
const FormVehicule = defineAsyncComponent(() => import('@/views/parc-auto/vehicules/FormVehicule.vue'));

export default defineComponent({
  name: "IndexVehicule",
  components: { NavParcAuto },
  data() {
    return {
      key: 1,
      lines: 0,
      affichage: "table",
      selection: [],
      table: "vehicules",
      columns: [
        {
          key: 'plaque',
          label: 'Immatriculation',
          exportable: true,
          sortable: true,
          sortable: true
        },
        {
          key: 'marque',
          label: 'Marque',
          exportable: true,
          sortable: true
        },
        {
          key: 'type_vehicule',
          label: 'Type / Tonnage',
          exportable: true,
          sortable: true
        },
        {
          key: 'proprietaire',
          label: 'Proprietaire',
          exportable: true,
        },
        {
          key: 'statut',
          label: 'Etat',
          selectable: true,
          sortable: true
        }
      ]
    };
  },
  methods: {
    openCreateModal() {
      this.$dialog.open(FormVehicule, {
        props: {
          header: "Nouveau véhicule",
          style: {
            width: "50vw"
          },
          modal: true
        }
      });
    },
    openShowModal(objData) {
      this.$dialog.open(ShowVehicule, {
        props: {
          header: "Vehicule " + objData.plaque,
          style: {
            width: "50vw"
          },
          modal: true
        },
        data: objData
      });
    },
    updateLines(nb_lines) {
      this.lines = nb_lines
    },
    changeAffichage(type) {
      this.affichage = type;
      this.key++
    },
    getSelection(selection) {
      this.selection = selection
    }
  },
});
</script>